import { Box, Skeleton, styled, Typography } from '@mui/material';

export const Image = styled('img')(`
  width: 40px;
  height: 40px;  
  object-fit: cover;
  user-select: none;
`);

export const ImageSkeleton = styled(Skeleton)(`
  width: 40px;
  height: 40px;
`);

export const CellContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'start',
  gap: 1,
});

export const CellTypography = styled(Typography)({
  padding: 0,
  margin: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
});

